import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ReactCodeInput from 'react-code-input';
import FormLabel from '@material-ui/core/FormLabel';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {},
  codeInputComponent: {
    position: 'relative',
    '& input[type=number]::-webkit-inner-spin-button': {
      appearance: 'none',
    },
    '& input': {
      marginRight: '20px',
      width: '20px',
      border: 'none',
      fontFamily: 'OpenSans',
      borderBottom: '1px solid #888888',
      fontSize: '19px',
      textAlign: 'center',
      paddingBottom: '5px',
      color: '#484848',
      backgroundColor: 'transparent',
      '&:last-child': {
        marginRight: '0px',
      },
      '&:focus': {
        outline: 'none',
        borderBottom: '1px solid #2979ff',
        backgroundColor: 'transparent',
      },
    },
    '@media (max-width: 767px)': {
      '& input': {
        borderRadius: '0px',
        paddingLeft: '.2em',
        paddingRight: '.2em',
        width: '18px',
      },
    },
    '@media (max-width: 360px)': {
      '& input': {
        width: '12px',
      },
    },
  },
  prefix: {
    marginRight: '30px',
    fontSize: '18px',
  },
  errorMessage: {
    color: theme.palette.$lipstick,
    fontSize: theme.typography.$fzH6,
  },
  placeholder: {
    color: '#b2bec4',
    fontSize: '14px',
    margin: 20,
  },
  label: {
    fontSize: '14px',
    color: theme.palette.$greyishBrown,
    marginBottom: '12px',
  },
  errorInput: {
    display: 'block',
  },
}));

const CodeInputCustom = ({
  getValue, placeholder, label, max, handleError, type, className, isPassword,
}) => {
  const classes = useStyles();
  const [error, setError] = useState(null);
  const [types, setTypes] = useState(type);
  const setValue = (value) => {
    if (isPassword) {
      setTypes('password');
    }
    if (value.length >= 1 && value.length < max) {
      handleError(true);
    } else {
      setError(null);
      getValue(value);
      handleError(false);
    }
  };
  return (
    <div>
      <FormLabel className={classes.label} component="legend">
        {label}
      </FormLabel>
      <ReactCodeInput
        onChange={setValue}
        className={clsx(classes.codeInputComponent, className)}
        type={isPassword ? types : type}
        value=""
        inputMode="numeric"
        fields={max}
        autoFocus={false}
      />
      {!error ? (
        <p className={classes.placeholder}>{placeholder}</p>
      ) : (
        <p className={classes.errorMessage}>{error}</p>
      )}
    </div>
  );
};

{
  /* <CodeInputCustom label="CDP Securities Account number" placeholder={'To find out your number, you may call CDP at +65 6535 7511'} getValue={(e) => console.log(e,"eee")}></CodeInputCustom> */
}
CodeInputCustom.defaultProps = {
  placeholder: '',
  getValue: _ => _,
  handleError: _ => _,
  label: '',
  type: 'number',
  className: '',
  isPassword: false,
};

CodeInputCustom.propTypes = {
  placeholder: PropTypes.string,
  getValue: PropTypes.func,
  handleError: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  max: PropTypes.number.isRequired,
  isPassword: PropTypes.bool,
};

export default CodeInputCustom;
